module.exports = __webpack_public_path__ + "assets/images/tribute_video_tn.a67a446b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/GalleryTeaser/assets/tribute_video_tn.jpg
// module id = 1685
// module chunks = 0